import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { DemoRegistrationFormService } from './services/demo-registration-form.service';

@Component({
    selector: 'app-kb-demo-registration',
    templateUrl: './kb-demo-registration.component.html',
    styleUrl: './kb-demo-registration.component.scss',
    standalone: false
})
export class KbDemoRegistrationComponent implements OnInit, OnDestroy {

  subscription = new Subscription();
  constructor(private documentService: GetDocumentService,
    private breadcrumbDataService: DemoRegistrationFormService
  ) {

  }

  ngOnInit() {
    
    this.subscription.add(
      this.breadcrumbDataService.getDemoBreadcrumb().subscribe((() => {
      })));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
